import type { AppSidebarData } from '@repo/ui';
import {
  CreditCard,
  LayoutDashboard,
  LifeBuoy,
  Link2,
  Monitor,
  Share2,
  Shield,
  TrendingUp,
  Trophy,
  User,
} from 'lucide-react';

export function getMyNavItems(): AppSidebarData['navMain'] {
  return [
    { title: 'Home', url: '/my', icon: LayoutDashboard, isActive: true },
    { title: 'Progress', url: '/my/progress', icon: TrendingUp },
    { title: 'Leaderboard', url: '/leaderboard', icon: Trophy },
    { title: 'Share', url: '/share', icon: Share2 },
    { title: 'Billing', url: '/my/billing', icon: CreditCard },
  ];
}

export function getAccountNavItems(): AppSidebarData['navMain'] {
  return [
    { title: 'Account', url: '/account', icon: LayoutDashboard },
    { title: 'Profile', url: '/account/profile', icon: User },
    { title: 'Integrations', url: '/account/integrations', icon: Link2 },
    { title: 'Security', url: '/account/security', icon: Shield },
    { title: 'Sessions', url: '/account/security/sessions', icon: Monitor },
    { title: 'Support', url: '/account/support', icon: LifeBuoy },
  ];
}
